import { useState, type MouseEvent } from 'react';
import { buildRecipeEditorialUrl, publicRecipeProduct } from '../config/recipe-links';
import type { FoodContainer } from '../domain/model';
import { useI18n } from '../i18n/I18nContext';
import { useApp } from './AppContext';
import { Icon } from './components';

export const RecipeIdeasCta = ({
  container,
  locale,
  onLocalRecipes,
}: {
  container: FoodContainer;
  locale: string;
  onLocalRecipes: (container: FoodContainer) => void;
}) => {
  const { runtime } = useApp();
  const { t } = useI18n();
  const [fallbackStatus, setFallbackStatus] = useState<string | null>(null);
  const publicProduct = publicRecipeProduct(container, locale);
  const editorialUrl = buildRecipeEditorialUrl(runtime.recipeSiteOrigin, container, locale);

  const open = (event: MouseEvent<HTMLAnchorElement>) => {
    if (editorialUrl != null && navigator.onLine) return;
    event.preventDefault();
    setFallbackStatus(
      editorialUrl == null ? t('recipe.catalogueUnavailable') : t('recipe.localFallback'),
    );
    onLocalRecipes(container);
  };

  return (
    <div className="recipe-ideas-cta">
      <a
        className="button button--secondary"
        href={editorialUrl?.toString() ?? '#'}
        onClick={open}
        referrerPolicy="no-referrer"
      >
        <Icon name="meal" />
        <span>{t('recipe.ideasWith', { product: publicProduct.label })}</span>
      </a>
      <small>{t('recipe.privacy')}</small>
      {fallbackStatus != null ? <small role="status">{fallbackStatus}</small> : null}
    </div>
  );
};
